import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.58.25a1 1 0 0 1 1 1v1.722h.814l.288.014a2.815 2.815 0 0 1 2.526 2.8v9.982a2.815 2.815 0 0 1-2.814 2.815H3.689a2.815 2.815 0 0 1-2.814-2.815V5.786a2.815 2.815 0 0 1 2.814-2.814h.816V1.25a1 1 0 0 1 2 0v1.722h7.074V1.25a1 1 0 0 1 1-1ZM2.874 15.768c0 .45.365.815.814.815h12.705c.45 0 .814-.365.814-.815V7.602H2.875v8.166Z" })
});
export default SvgCalendar;
